<div
    class="benefitsCardContainer"
    [style.background-color]="'#' + (benefits?.plan?.provider?.colour || benefits?.benefitPlan?.benefitProvider?.color)"
>
    <div class="benefitsCardWhiteOverlay"></div>
    <div class="benefitsCardHeader">
        <div
            class="benefitsCardCarrierLogo"
            [style.background-image]="'url(/assets/img/brands/' + benefits?.benefitPlan?.benefitProvider?.logoUrl + ')'"
        ></div>
        <p class="benefitsCardCompanyTitle align-right darkText font-bold">{{ employee?.account?.fullName }}</p>
        <p class="benefitsCardCompanySubTitle align-right grayText">
            {{ 'components.benefits-card.employeeBenefitsCard' | translate }}
        </p>
    </div>

    <!-- Manual Card details -->
    <div class="benefitsCardFloater">
        <p class="benefitsFloaterTitle align-left darkText">
            {{ benefits?.card_title_1 || benefits?.cardTitlePrimary }}
        </p>
        <p class="benefitsFloaterValue align-left grayText text-small">
            {{ benefits?.card_value_1 || benefits?.cardValuePrimary }}
        </p>
    </div>
    <div class="benefitsCardFloater">
        <p class="benefitsFloaterTitle align-left darkText">
            {{ benefits?.card_title_2 || benefits?.cardTitleSecondary }}
        </p>
        <p class="benefitsFloaterValue align-left grayText text-small">
            {{ benefits?.card_value_2 || benefits?.cardValueSecondary }}
        </p>
    </div>
    <div class="benefitsCardFloater">
        <p class="benefitsFloaterTitle align-left darkText">
            {{ benefits?.card_title_3 || benefits?.cardTitleTertiary }}
        </p>
        <p class="benefitsFloaterValue align-left grayText text-small">
            {{ benefits?.card_value_3 || benefits?.cardValueTertiary }}
        </p>
    </div>
</div>
